import { render } from "./BoardList.vue?vue&type=template&id=ecec763c"
import script from "./BoardList.vue?vue&type=script&lang=js"
export * from "./BoardList.vue?vue&type=script&lang=js"

import "./BoardList.vue?vue&type=style&index=0&id=ecec763c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__